import { useRouter } from "next/router";
import { useEffect } from "react";

import { useIsMounted } from "@hooks/useIsMounted";
import { useStore } from "@hooks/useZustandProvider";

export const UserLayout = ({ children }) => {
  const { route, ...router } = useRouter();

  const { user } = useStore();
  const { isCorporate, email } = user;
  const isMounted = useIsMounted();

  useEffect(() => {
    if (isMounted) {
      if (isCorporate || email) {
        return;
      }

      if (route.startsWith("/profile")) {
        router.push("/");
      }
    }
  }, [email, isMounted, isCorporate]);

  return children;
};
